<template>
  <the-content v-model="showFilters">

    <template v-slot:content>
      <div class="list-grid mh2-l mv2">
        <journal-list-item v-for="(item, index) in filteredStatusesHistory" :key="index" :item="item" :showClaim="true"></journal-list-item>
      </div>
    </template>

    <template v-slot:sidebar>
      <filters :root-module='rootModule' :dateRangePlaceholder='dateRangePlaceholder' />
    </template>

    <template v-slot:mobile-sidebar>
      <filters :root-module='rootModule' :dateRangePlaceholder='dateRangePlaceholder' />
    </template>

  </the-content>
</template>

<script>
import TheContent from '@/components/Content.vue'
import Filters from '@/components/claims/Filters.vue'
import JournalListItem from '@/components/claims/JournalListItem.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    TheContent,
    Filters,
    JournalListItem
  },
  data () {
    return {
      rootModule: 'claim/journal',
      dateRangePlaceholder: 'Событие в интервале',
      showFilters: false
    }
  },
  computed: {
    ...mapGetters('claim/journal', ['filteredStatusesHistory'])
  }
}
</script>

<style lang="scss" scoped>
</style>
